<template>
  <div>
    <el-form
      :inline="true"
      label-position="top"
      size="mini"
      @submit.prevent.native="refreshData()"
    >
      <div>
        <el-form-item>
          <label slot="label">FFN</label>
          <el-input v-model="filter.ffn" type="search"></el-input>
        </el-form-item>
        <el-form-item>
          <label slot="label">Nro de ticket</label>
          <el-input v-model="filter.ticketNumber" type="search"></el-input>
        </el-form-item>
        <el-form-item>
          <label slot="label">Nro de cupón</label>
          <el-input v-model="filter.couponNumber" type="search"></el-input>
        </el-form-item>
        <el-form-item>
          <label slot="label">Flujo</label>
          <el-input v-model="filter.flow" type="search"></el-input>
        </el-form-item>
        <el-form-item>
          <label slot="label">Event</label>
          <el-input v-model="filter.event" type="search"></el-input>
        </el-form-item>
        <el-form-item>
          <label slot="label">Event Result</label>
          <el-input v-model="filter.eventResult" type="search"></el-input>
        </el-form-item>
        <el-form-item>
          <label slot="label">Inicio</label>
          <el-date-picker
            v-model="filter.startAt"
            type="date"
            placeholder="Seleccionar fecha"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <label slot="label">Fin</label>
          <el-date-picker
            v-model="filter.endAt"
            type="date"
            placeholder="Seleccionar fecha"
            @change="convertEndDateToEndOfDay"
          >
          </el-date-picker>
        </el-form-item>
      </div>
      <div style="text-align: right">
        <el-form-item>
          <el-button type="primary" native-type="submit"> Buscar </el-button>
        </el-form-item>
      </div>
    </el-form>

    <el-table
      v-loading="loading"
      :data="logs"
      stripe
      :height="600"
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="Timestamp">
        <template slot-scope="scope">{{
          moment(
            scope.row.timestamp.seconds * 1000 +
              scope.row.timestamp.nanos / 1000000
          ).format("DD-MM-YYYY HH:mm:ss")
        }}</template>
      </el-table-column>
      <el-table-column
        label="Flujo"
        prop="jsonPayload.fields.flow.stringValue"
      ></el-table-column>
      <el-table-column
        label="Event"
        prop="jsonPayload.fields.event.stringValue"
      ></el-table-column>
      <el-table-column
        label="Event result"
        prop="jsonPayload.fields.eventResult.stringValue"
      ></el-table-column>
      <el-table-column
        label="FFN"
        prop="jsonPayload.fields.ffn.stringValue"
      ></el-table-column>
      <el-table-column
        label="Ticket Number"
        prop="jsonPayload.fields.ticketNumber.stringValue"
      ></el-table-column>
      <el-table-column
        label="Coupon Number"
        prop="jsonPayload.fields.couponNumber.numberValue"
      >
      </el-table-column>
      <el-table-column
        label="Endpoint"
        prop="jsonPayload.fields.endpoint.stringValue"
      >
      </el-table-column>
      <el-table-column
        label="Status"
        prop="jsonPayload.fields.status.numberValue"
      >
      </el-table-column>
      <el-table-column fixed="right" label="Acciones">
        <template slot-scope="scope">
          <button
            v-if="scope.row.jsonPayload.fields.request"
            type="button"
            class="btn btn-primary btn-sm"
            @click="showDetails(scope.row)"
          >
            Detalles
          </button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="detailDialogVisible">
      <div v-if="detailDialogRow">
        <div>Request:</div>
        <span class="textarea-code">{{
          prettyjson(detailDialogRow.jsonPayload.fields.request.stringValue)
        }}</span>
        <br />
        <div>Response:</div>
        <span class="textarea-code">{{
          prettyjson(detailDialogRow.jsonPayload.fields.response.stringValue)
        }}</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import xmlFormat from "xml-formatter";
import _ from "lodash";

export default {
  data() {
    const urlParams = new URLSearchParams(window.location.search);

    return {
      loading: false,
      logs: [],
      detailDialogVisible: false,
      detailDialogRow: null,
      filter: {
        ffn: "",
        ticketNumber: "",
        couponNumber: "",
        flow: urlParams.get("flow"),
        event: urlParams.get("event"),
        eventResult: urlParams.get("eventResult"),
        startAt: urlParams.get("startAt")
          ? new Date(urlParams.get("startAt"))
          : moment().subtract(1, "week").startOf("day").toDate(),
        endAt: urlParams.get("endAt")
          ? new Date(urlParams.get("endAt"))
          : moment().endOf("day").toDate(),
      },
    };
  },
  computed: {
    moment() {
      return moment;
    },
  },
  created() {
    this.refreshData();
  },
  methods: {
    convertEndDateToEndOfDay() {
      this.filter.endAt = moment(this.filter.endAt).endOf("day").toDate();
    },
    refreshData() {
      this.loading = true;
      axios
        .get("api/v1/backend/gcp-logs", {
          params: this.filter,
        })
        .then((response) => {
          this.logs = response.data;
        })
        .then(() => {
          this.loading = false;
        });
    },
    showDetails(row) {
      this.detailDialogRow = row;
      this.detailDialogVisible = true;
    },
    prettyjson(stringValue) {
      try {
        return JSON.stringify(JSON.parse(stringValue), null, 2);
      } catch (err) {
        // eslint-disable-next-line no-empty
      }

      try {
        return xmlFormat(stringValue, {
          indentation: "  ",
          collapseContent: true,
        });
      } catch (err) {
        // eslint-disable-next-line no-empty
      }

      return stringValue;
    },
    tableRowClassName({ row }) {
      const status = _.get(row, "jsonPayload.fields.status.numberValue");
      const eventResult = _.get(
        row,
        "jsonPayload.fields.eventResult.stringValue"
      );
      if (status >= 500) return "danger-row";
      if (eventResult !== "success") return "warning-row";
      return null;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input {
  width: 122px;
}
::v-deep .el-date-editor {
  width: 130px;
}
.textarea-code {
  background-color: black;
  color: white;
  width: 100%;
  max-height: 200px;
  font-family: monospace;
  white-space: pre-wrap;
  overflow: auto;
  display: block;
  font-size: 12px;
}
::v-deep .el-table {
  tr {
    &.warning-row td {
      background: oldlace !important;
    }
    &.danger-row td {
      background: pink !important;
    }
    td {
      .cell {
        word-break: break-word;
      }
    }
  }
}
</style>
